import { render, staticRenderFns } from "./PolTypeDet.vue?vue&type=template&id=9e70f00c&"
import script from "./PolTypeDet.vue?vue&type=script&lang=js&"
export * from "./PolTypeDet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports